<template>
  <div class="rec">
    <div
      class="m-smallBan"
      :style="{
        height: '404px',
        backgroundImage: 'url(' + banner + ')'
      }"
    ></div>
    <div class="g-box">
      <div class="rec-tab">
        <div class="rec-tab-item">
          <div class="num">1</div>
          <div class="cap">华博特大学</div>
          <div class="text">
            华博特专业讲师队伍，结合线上、线下
            培训项目，让你随时随地，想学就学， 助力职业生涯各个阶段的成长发展。
          </div>
        </div>
        <div class="rec-tab-item">
          <div class="num">2</div>
          <div class="cap">新员工培训</div>
          <div class="text">
            我们为每一位新员工准备了分阶段培养
            项目，针对不同职类、不同部门采取定
            制化培养内容，通过多样化教学方式结
            合，带领新员工快速掌握专业技能、业 务知识等。
          </div>
        </div>
        <div class="rec-tab-item">
          <div class="num">3</div>
          <div class="cap">管理层培训</div>
          <div class="text">
            无论是新晋经理、中层干部等，华博特
            分层级、分阶段定制管理提升课程表，
            提升管理水平、领导魅力、战略经营思
            维，更开设企业总裁管理研修班，助力 优秀人才更进一步！
          </div>
        </div>
        <div class="rec-tab-item">
          <div class="num">4</div>
          <div class="cap">内部人才流动</div>
          <div class="text">
            公司岗位内部开放，只要符合条件，可
            以申请转岗，更多有趣、更多挑战、更 多可能！
          </div>
        </div>
      </div>
      <div class="rec-hd">
        <div class="rec-cap">优秀同事</div>
      </div>
      <div class="rec-YesTea swiper-container">
        <div class="swiper-wrapper">
          <router-link
            v-for="(item, index) in list"
            :key="index"
            :to="'/yes_teacher/' + item.id"
            class="swiper-slide m-h"
          >
            <div
              class="img"
              :style="{
                backgroundImage: 'url(' + item.cover + ')'
              }"
            ></div>
            <div class="cap">{{ item.title }}</div>
            <div class="text">{{ $fun.time(item.hireDate, "yyyy-MM-dd") }}</div>
          </router-link>
        </div>
      </div>
      <RecList />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import RecList from "../../components/RecList";
import Swiper from "swiper";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      banner: ""
    };
  },
  components: { RecList },
  mounted() {},
  methods: {
    async init() {
      this.$api.cms.web.coworker_listForClient.get().then(res => {
        this.list = res.data;
        this.$nextTick(() => {
          new Swiper(".rec-YesTea", {
            slidesPerView: 4,
            spaceBetween: 27,
            autoplay: {
              delay: 3000
            }
          });
        });
      });
      this.banner = await this.getMenuConfig("集团招聘Banner", "image");
    }
  }
};
</script>
<style lang="less">
.rec {
  padding-bottom: 110px;
}
.rec-tab {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.rec-tab-item {
  flex-shrink: 0;
  width: 270px;
  height: 326px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 220, 220, 1);
  margin-right: 37px;
  padding: 0 16px;
  box-sizing: border-box;
  &:nth-child(4n) {
    margin-right: 0;
  }
  .num {
    color: #ffffff;
    font-size: 42px;
    width: 86px;
    height: 86px;
    line-height: 86px;
    text-align: center;
    background: rgba(255, 207, 185, 1);
    margin: 24px auto 0 auto;
    border-radius: 50%;
  }
  .cap {
    color: #606060;
    font-size: 18px;
    margin-top: 40px;
    text-align: center;
  }
  .text {
    color: #979797;
    line-height: 20px;
    margin-top: 16px;
  }
}
.rec-hd {
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.rec-cap {
  color: #282828;
  font-size: 20px;
}
.rec-hd-btn {
  color: #ffffff;
  text-align: center;
  width: 90px;
  height: 36px;
  line-height: 36px;
  background: rgba(253, 143, 93, 1);
  border-radius: 4px;
}
.rec-YesTea {
  margin-top: 41px;
  &.swiper-container {
    .swiper-wrapper {
      .swiper-slide {
        width: 280px;
        height: 326px;
        background: rgba(249, 249, 249, 1);
      }
    }
  }
  .img {
    height: 200px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .cap {
    color: #606060;
    font-size: 18px;
    line-height: 25px;
    margin: 24px 14px 0 14px;
    height: 50px;
    overflow: hidden;
  }
  .text {
    color: #979797;
    margin: 8px 14px 0 14px;
  }
}
</style>
